const state = {
  alerts: {
    initial: [],
    fromRefresh: {}
  },
}
const getters = {
  getAlerts: state => state.alerts.initial,
  getNewAlertsFromRefresh: state => state.alerts.fromRefresh,
  newAlertsArr: state => {
    let arr = []
    for (let alert of Object.values(state.alerts.fromRefresh)) {
      arr.push(alert)
    }
    return arr
  }
}
const mutations = {
  setAlerts(state, arr) {
    state.alerts.initial = arr
  },
  setAlertsFromRefresh(state, arr) {
    state.alerts.fromRefresh = {}
    for (let alert of arr) {
      state.alerts.fromRefresh[alert.id] = alert
    }
  },
  moveAlertToInitialBatch(state, alert) {
    delete state.alerts.fromRefresh[alert.id]
    state.alerts.initial.unshift(alert)
  }
}
  
export default {
  state,
  getters,
  mutations
}